<template>
  <div>
    <vAlertHeader title="OR Pay with PayPal" color="#012169"></vAlertHeader>
    <div v-if="!sdkLoaded">Loading PayPal...</div>
    <div v-else id="paypal-button-container"></div>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
export default {
  name: "PayPalPayment",
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  components: { vAlertHeader },
  props: {
    selectedPlan: {
      default: null,
    },
    company: {
      default: null,
    },
  },
  data() {
    return {
      sdkLoaded: false,
      amount: 0,
      clientID:
        "AZy95ZrflAWNXHefRJ59u6BPG5--EmH3SdO9D16TFpmqNFqEQZPrfaeVg69zT9bLDbHZLFMSDUCOSWKY",
    };
  },
  watch: {
    async selectedPlan(newVal) {
      this.amount = this.stripNonDigitsAndCommasFromMoney(newVal.price);
      await this.convertCurrencyToDollar(newVal);
      this.loadPayPalScript();
    },
  },
  async mounted() {
    if (this.selectedPlan && this.selectedPlan.price) {
      this.amount = this.stripNonDigitsAndCommasFromMoney(
        this.selectedPlan.price
      );
      await this.convertCurrencyToDollar(this.selectedPlan);
    } else {
      alert("You Need To Start Afresh!");
      this.$router.push({ path: "/" });
    }

    this.loadPayPalScript();
  },
  methods: {
    stripNonDigitsAndCommasFromMoney(price) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(price);
    },
    loadPayPalScript() {
      // If SDK is already loaded
      if (window.paypal) {
        this.sdkLoaded = true;
        this.$nextTick(this.renderPayPalButton);
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://www.paypal.com/sdk/js?client-id=" +
        this.clientID +
        "&currency=USD";
      script.onload = () => {
        this.sdkLoaded = true;
        this.$nextTick(this.renderPayPalButton);
      };
      script.onerror = () => {
        console.error("Failed to load PayPal SDK.");
      };
      document.head.appendChild(script);
    },

    renderPayPalButton() {
      if (!window.paypal) {
        console.error("PayPal SDK not available.");
        return;
      }

      const container = document.getElementById("paypal-button-container");
      if (!container) {
        console.error("PayPal button container not found.");
        return;
      }

      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: this.amount,
                  },
                },
              ],
            });
          },
          onApprove: (data, actions) => {
            return actions.order.capture().then((details) => {
              this.$toast.success("Coupon Code Accepted", { duration: 3000 });
              localStorage.setItem("garbage", this.company.emis);
              this.$router.push({ path: "/payment-complete" });
              //   alert(
              //     `Payment of $${this.amount} completed by ${details.payer.name.given_name}`
              //   );
            });
          },
          onError: (err) => {
            console.error("PayPal error:", err);
            alert("Payment failed.");
          },
        })
        .render("#paypal-button-container");
    },
    async convertCurrencyToDollar(plan) {
      if (this.getCurrency == "ZAR") {
        const currencyConversionRate =
          await helpersJs.getCurrencyConversionRateFromFrankfurterApi(
            "ZAR",
            "USD"
          );
        plan.price = helpersJs.convertCurrencyFrankfurterApi(
          parseFloat(plan.price),
          currencyConversionRate
        );
        this.amount = plan.price;
      }
    },
  },
};
</script>
